var map = {
	"./Project-Images/CloudKicker1.png": 44,
	"./Project-Images/EcoSymphony.png": 45,
	"./Project-Images/GigWrangler1.png": 46,
	"./Project-Images/JetFuel1.png": 47,
	"./Project-Images/Karma2.png": 48,
	"./Project-Images/Karma2.svg": 49,
	"./Project-Images/MovieTracker1.png": 50,
	"./Project-Images/Symphony.png": 51,
	"./Project-Images/computer.svg": 52,
	"./Project-Images/config-hist.png": 53,
	"./Project-Images/config-history.png": 54,
	"./Project-Images/dt4.png": 55,
	"./Project-Images/ethernow.png": 56,
	"./Project-Images/github.svg": 57,
	"./Project-Images/onboard-1.png": 58,
	"./Project-Images/ooc-logo.png": 59,
	"./Project-Images/ooc.png": 60,
	"./ProjectDetails": 4,
	"./ProjectDetails.css": 15,
	"./ProjectDetails.js": 4,
	"./Projects": 3,
	"./Projects-Data": 2,
	"./Projects-Data.js": 2,
	"./Projects.css": 14,
	"./Projects.js": 3
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;